module.exports = __webpack_public_path__ + "static/img/9.2d92a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/9.png
// module id = Rw83
// module chunks = 4